__turbopack_context__.v({
  "button": "four-steps-module-scss-module__14_aJq__button",
  "content": "four-steps-module-scss-module__14_aJq__content",
  "placeholder": "four-steps-module-scss-module__14_aJq__placeholder",
  "section": "four-steps-module-scss-module__14_aJq__section",
  "title": "four-steps-module-scss-module__14_aJq__title",
});
